import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserService } from '../../Account/user.service';
import { IWeissmanModalComponent } from '../../Compliance/WeissmanModalService';
import { CarouselComponent, Slide } from '../../UI-Lib/Carousel/carousel.component';
import { AccountService } from '../../User/account.service';
import { TopNavService } from '../Top-Nav/topNav.service';

import { ModalWrapperComponent } from '../../UI-Lib/Modal-Wrapper/modalWrapper.component';

@Component({
    selector: 'nav-onboarding',
    templateUrl: './navOnboarding.component.html',
    styles: [
        `
            span {
                font-size: 16px;
            }
            .number-dot {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 13px 13px;
                gap: 8px;
                width: 24px;
                height: 24px;
                background: #edad49;
                color: #fff;
                border-radius: 12px;
                font-size: 18px;
                line-height: 18px;
                flex: none;
                order: 0;
                flex-grow: 0;
                margin: 0 15px 0 5px;
            }
        `,
    ],
    imports: [ModalWrapperComponent, CarouselComponent],
})
export class NavOnboardingComponent implements AfterViewInit, IWeissmanModalComponent<void, void> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _topNavService: TopNavService,
        private readonly _accountService: AccountService,
        private readonly _userService: UserService,
    ) {}

    @ViewChild('template1') template1: TemplateRef<any>;
    @ViewChild('template2') template2: TemplateRef<any>;
    @ViewChild('template3') template3: TemplateRef<any>;
    @ViewChild('template4') template4: TemplateRef<any>;

    params: void;
    result: void;

    title: string = 'Value Enhancement News';

    slides: Slide[] = [{ template: null }, { template: null }, { template: null }, { template: null }];
    currentSlide: number = 0;

    ngAfterViewInit(): void {
        this.slides[0].template = this.template1;
        this.slides[1].template = this.template2;
        this.slides[2].template = this.template3;
        this.slides[3].template = this.template4;
    }

    get progressBtnLabel(): string {
        return this.currentSlide === this.slides.length - 1 ? 'FINISH' : 'NEXT';
    }

    progress(): void {
        if (this.currentSlide < this.slides.length - 1) {
            this.currentSlide++;
        } else {
            this.cancel();
        }
    }

    async cancel(fromHashChange: boolean = false): Promise<void> {
        if (fromHashChange) {
            return;
        }
        if (this._userService.getUser().onboardingStatus === Core.UserOnboardingStatusEnum.NoAction) {
            await this._accountService.updateOnboardingStatus(Core.UserOnboardingStatusEnum.Completed);
        }
        this._topNavService.showOnboardingBanner();
        this._bsModalRef.hide();
    }
}
